<template>
  <div class="body-bg">
    <div style="position: fixed;">
      <img src="~@/assets/images/zy/bg.jpg" />
    </div>

    <!-- <audio
    ref="music"
      id="memberAudio"
      src="http://api.xiaoaitt.com/UploadFiles/Music/2017/11/24/Heaven/MusicInfo/20171124154955.mp3"
      loop
      autoplay="autoplay"
      preload="auto"
    ></audio> -->
    <svg
      viewBox="0 0 800 600"
      xmlns="https://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <filter id="brightness">
          <feComponentTransfer>
            <feFuncR type="linear" slope="0.3" />
            <feFuncG type="linear" slope="0.3" />
            <feFuncB type="linear" slope="0.3" />
          </feComponentTransfer>
        </filter>
        <radialGradient
          id="lanternGrad"
          cx="33.4551"
          cy="63.1367"
          r="59.6359"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style="stop-color:#FCFFDD" />
          <stop offset="0.1218" style="stop-color:#FFFEB8" />
          <stop class="lanternMid" offset="0.2386" style="stop-color:#FCF954" />
          <stop class="flicker" offset="0.5838" style="stop-color:#FF510F" />
          <stop class="flicker" offset="0.9036" style="stop-color:#501004" />
          <stop class="flicker" offset="0.9492" style="stop-color:#3D0A06" />
          <stop class="lanternTop" offset="1" style="stop-color:#501004" />
        </radialGradient>
        <path
          id="lantern"
          ref="lantern"
          fill="url(#lanternGrad)"
          d="M47.7,61.6c0,2.6-6.3,5.6-14.7,5.6s-14.7-2.9-14.7-5.6c0-2.6,6.3-5.6,14.7-5.6S47.7,58.9,47.7,61.6z
	 M26.4,0C19.2,0-1.5,15.1,0.1,21.4C1.6,27.7,15.4,62,15.4,62s0.1,0.1,0.2,0.3c-0.1-0.3-0.1-0.5-0.1-0.8c0-4.7,7.5-8.3,17.4-8.3
	c9.9,0,17.4,3.6,17.4,8.3c0,0.1,0,0.2,0,0.2c2-3.6,10.9-33.1,11.9-42.7C63.3,9.3,34.2,0,26.4,0z"
        />
        <!-- <path id="bigHeart" d="M466.5,307.1l-76.4,65.2l-75.5-65.2l0,0c-12.2-11.6-19-28.9-15.6-47.7c3.8-21.4,21.3-38.6,42.8-42
	c19.5-3.1,37.4,4.5,48.7,17.9c11.3-13.4,29.2-21.1,48.7-17.9c21.5,3.5,39,20.6,42.8,42.1C485.5,278.2,478.8,295.5,466.5,307.1z" /> -->
        <path
          id="cloud"
          d="M499.9,274.3c0-1,0.1-2.1,0.1-3.1c0-38.2-31-69.2-69.2-69.2c-27.7,0-51.6,16.2-62.6,39.7
	c-6.1-4.4-13.7-7-22-7c-20.5,0-37.1,16-37.1,35.8c0,2.9,0.4,5.8,1.1,8.5c-23.3,5-40.9,26.1-40.9,51.4c0,29,23,51.1,51.4,51.1h168.7
	c27.2,0,49.2-23.2,49.2-53.6C538.6,301.7,522,279.7,499.9,274.3z"
        />
        <mask id="cloudMask">
          <rect width="800" height="600" />
          <!-- <use xlink:href="#bigHeart" fill="#FFF" /> -->
        </mask>
        <mask id="cloudMaskInv">
          <rect width="800" fill="#FFF" height="600" />
          <!-- <use xlink:href="#bigHeart" /> -->
        </mask>
        <path
          id="heart"
          fill="#CC3232"
          d="M18.9,3.7c3.3-4,8.3-4.5,12.6-2.6c3.9,1.7,6.4,5.7,6.4,9.9l0,0c0,3.2-1.4,6.1-3.6,8.1h0
	L22.5,31c-0.9,0.9-2.1,2.4-3.6,2.4c-1.4,0-2.6-1.5-3.6-2.4L3.5,19.1C-1,15-1.2,7.7,3.1,3.3C7.5-1,14.8-0.9,18.9,3.7z"
        />
      </defs>
      <!-- 
      <rect fill="url(#bgGrad)" width="100%" height="600" /> -->
      <g ref="heartContainer" class="heartContainer" mask="url(#cloudMask)"></g>
      <g
        ref="heartContainerInv"
        class="heartContainerInv"
        mask="url(#cloudMaskInv)"
      ></g>
    </svg>
    <div class="container">
      <!-- <div class="line" style="--color:orange;--x:5;--z:1;--d:3;"></div>
      <div class="line" style="--color:#fd79a8;--x:4;--z:0;--d:1;"></div> -->
      <div class="line" style="--color:#fff;--x:8;--z:-15;--d:18; "></div>
      <div class="line" style="--color:#fff;--x:8;--z:-5;--d:28; "></div>
      <div class="line" style="--color:#fff;--x:18;--z:-8;--d:14; "></div>
      <div class="line" style="--color:#fff;--x:8;--z:-9;--d:22; "></div>
      <div class="line" style="--color:#fff;--x:9;--z:-1;--d:40; "></div>
      <div class="line" style="--color:#fff;--x:10;--z:-2;--d:34; "></div>
      <div class="line" style="--color:#fff;--x:3;--z:2;--d:10; "></div>
    </div>

    <div class="home" @click="goHome">
      <a href="#" title="返回首页">返回首页</a>
    </div>
    <div class="jilu">
      <router-link to="/GiftRecord2">祈福记录</router-link>
    </div>
    <div :class="isMusicPay ? 'musicAni' : 'music'" @click="clickmusic()">
      <a href="#" title="音乐"></a>
    </div>
    <!-- <div class="tanmu"><a href="#" title="弹幕">弹幕</a></div> -->
    <div class="fenxiang" @click="onShare()">
      <a href="#" title="分享">分享</a>
    </div>
    <!-- <div class="message"><a href="#" title="留言">留言</a></div> -->

    <div class="fulan">
      <div class="xiang" align="center">
        <img
          src="@/assets/images/zy/xiang.gif"
          width="40"
          height="109"
          alt=""
        />
      </div>
      <div class="lan-a" align="center">
        <img src="@/assets/images/zy/la.gif" width="60" height="109" alt="" />
      </div>
      <div class="lan-b" align="center">
        <img src="@/assets/images/zy/la.gif" width="60" height="109" alt="" />
      </div>
      <!-- <div class="huogong">
 
      </div> -->
      <canvas
        id="canvas"
        class="huogong2"
        ref="huogong2"
        height="140"
        width="100"
      ></canvas>
      <div v-for="(item, index) in sacrificePaths" v-bind:key="index">
        <div :id="'jp_img' + index" :class="'jp_img'">
          <img :src="item" />
        </div>
      </div>

      <vue-seamless-scroll
        v-if="vActivity != null"
        :data="vActivity.ActivitySacrificeLogList"
        class="sao-list"
        :class-option="classOption"
      >
        <ul id="img-list">
          <li
            v-for="(item, index) in vActivity.ActivitySacrificeLogList"
            :key="index"
          >
            <div class="sao-list-a">
              <img
                :src="item.HeadPic"
                width="200"
                height="200"
                :alt="item.NickName"
              />
            </div>
            <div class="sao-list-b">
              <span style="color: #eb9904; ">{{ item.NickName }}</span>
              <span style="color: #ffffff; ">{{ item.Desc }}</span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
      <!-- <div class="sao-list">
     
      </div> -->
      <div class="saozi" @click="goSacrifice">
        <p>
          已有{{ vActivity != null ? vActivity.TotalSacrificeCount : 0 }}人烧过
        </p>
      </div>
      <div class="guan">
        <router-link to="/Create" title="创建纪念馆"> 创建纪念馆</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import soshm from "soshm";
import gsap from "gsap";
import { Toast } from "vant";
import vueSeamlessScroll from "vue-seamless-scroll";
import wx from "weixin-js-sdk";

export default {
  data() {
    return {
      isMusicPay: true,
      trackEnded: false,
      sacrificePaths: [],
      classOption: {
        singleHeight: 40,
      },
      isShowFire: false,
      vActivity: null,
      lx: [],
      aniImg: [
        require("@/assets/images/zy/hl/sbl0001.png"),
        require("@/assets/images/zy/hl/sbl0002.png"),
        require("@/assets/images/zy/hl/sbl0003.png"),
        require("@/assets/images/zy/hl/sbl0004.png"),
        require("@/assets/images/zy/hl/sbl0005.png"),
        require("@/assets/images/zy/hl/sbl0006.png"),
        require("@/assets/images/zy/hl/sbl0007.png"),
        require("@/assets/images/zy/hl/sbl0008.png"),
        require("@/assets/images/zy/hl/sbl0009.png"),
        require("@/assets/images/zy/hl/sbl0010.png"),
        require("@/assets/images/zy/hl/sbl0011.png"),
        require("@/assets/images/zy/hl/sbl0012.png"),
        require("@/assets/images/zy/hl/sbl0013.png"),
        require("@/assets/images/zy/hl/sbl0014.png"),
        require("@/assets/images/zy/hl/sbl0015.png"),
        require("@/assets/images/zy/hl/sbl0016.png"),
      ],
    };
  },
  components: {
    vueSeamlessScroll,
  },
  mounted() {
    this.makeHearts();

    // wx.ready(function() {
    //   document.querySelector("#memberAudio").play();
    // })

    if (typeof WeixinJSBridge === "undefined") {
      //未执行WeixinJSBridge 开始监听 WeixinJSBridge
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          this.$refs.music.play();
        },
        false
      );
    } else {
      //已经执行 使用 getNetworkType 调用获取网络类型后执行
      WeixinJSBridge.invoke("getNetworkType", {}, () => {
        this.$refs.music.play();
      });
    }
    this.ani();
  },
  methods: {
    init() {
      var that = this;
      that.$store
        .dispatch({
          type: "ActivityZyj",
        })
        .then((res) => {
          that.vActivity = res;
        });
    },
    makeHearts() {
      var heartContainer = this.$refs.heartContainer;
      var heartContainerInv = this.$refs.heartContainerInv;
      gsap.set("svg", {
        visibility: "visible",
      });

      gsap.to(
        ".flicker",
        2.8,
        {
          stopColor: "#BF3A0B",
          repeat: -1,
          ease:
            "rough({template: Power0.easeNone,strength: 3,points: 10,taper: 'none',randomize: true,clamp: false})",
          yoyo: true,
        },
        0.1
      );

      gsap.to(".lanternTop", 0.6, {
        stopColor: "#000",
        repeat: -1,
        ease:
          "rough({template: Power0.easeNone,strength: 3,points: 10,taper:'none',randomize: true,clamp: false})",
        yoyo: true,
      });

      gsap.to(".lanternMid", 0.6, {
        stopColor: "#FD9E2E",
        repeat: -1,
        ease:
          "rough({template: Power0.easeNone,strength: 3,points: 10,taper: 'none',randomize: true,clamp: false})",
        yoyo: true,
      });

      var h, destContainer;
      for (var i = 0; i < 50; i++) {
        h = this.$refs.lantern.cloneNode(true);
        destContainer = heartContainer;
        if (i % 2) {
          destContainer = heartContainerInv;
        }
        destContainer.appendChild(h);
        var speed = this.randomBetween(5, 20);
        gsap.set(h, {
          x: this.randomBetween(0, 800),
          scale:
            destContainer == heartContainerInv
              ? 1 - speed * 0.05
              : this.randomBetween(6, 15) / 10,
          //alpha:(destContainer == heartContainerInv) ?3/speed  : 1,
          filter:
            destContainer == heartContainerInv ? "url(#brightness)" : "none",
          //filter:'brightness(-20%)',
          //backgroundColor:'hsl(150, +=0, 100%)',
          transformOrigin: "50% 0%",
        });
        var t = gsap.fromTo(
          h,
          speed,
          {
            y: this.randomBetween(400, 650),
          },
          {
            y: this.randomBetween(-140, -180),
            delay: this.randomBetween(0, 10),
            repeat: -1,
            onRepeat: this.checkTrack,
            repeatDelay: this.randomBetween(0, 10),
            ease: "Linear.easeNone",
          }
        );

        // sway(h);
        t.timeScale(0.24);
      }
    },
    randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    checkTrack() {
      if (this.trackEnded) {
        gsap.killTweensOf(this.target);
      }
    },
    goSacrifice() {
      this.$router.push("/GiftList2");
    },
    goHome() {
      //this.jpAnimation();
      this.$router.replace("/");
    },
    jpAnimation() {
      //console.log("jpAnimation");
      let tl = gsap.timeline({
        repeat: 0,
      });

      for (var i = 0; i < this.sacrificePaths.length; i++) {
        tl.fromTo(
          "#jp_img" + i + "",
          { y: -120, opacity: 0 },
          { opacity: 1, y: 90, duration: 5 }
        );
      }
    },
    getDataList() {},
    scroll() {},
    clickmusic() {
      let memberAudio = document.querySelector("#memberAudio");
      if (this.isMusicPay) {
        this.isMusicPay = false;
        memberAudio.pause();
      } else {
        this.isMusicPay = true;
        memberAudio.play();
      }
    },
    loadImage(url, callback) {
      var image = new Image();
      (image.onload = function() {
        (image.onload = null), callback(image);
      }),
        (image.src = url);
    },
    onShare() {
      if (this.$weixin.IsWeiXin()) {
        soshm.weixinSharetip();
      } else {
        Toast("当前暂不支持分享");
      }
    },
    ani() {
      const canvas = this.$refs.huogong2;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      var i = 0;

      this.mySetInterval(() => {
        img.src = this.aniImg[i];
        img.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, 80, 120);
        };
        i++;
        if (i === 16) {
          i = 0;
        }
      }, 200);
    },
    mySetInterval(func, detay) {
      var i = 0;
      var myReq = requestAnimationFrame(function fn() {
        // 判断现在处于60帧的第几帧，如果是目标帧的话，调用func函数：
        if (i % parseInt(60 / (1000 / detay)) == 0) {
          // console.log(i,"mySetInterval");
          func();
        }
        i++;
        // 让i值每秒增加60，循环调用func函数：
        requestAnimationFrame(fn);
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "GiftList2") {
      from.meta.refresh = true;
    }
    next();
  },
  beforeDestory() {},
  destroyed() {},
  activated() {
    var that = this;
    var _sacrifice = this.$store.state.sacrificemodel;
    var _sacrificeList = this.$store.state.sacrificemodelList;
    this.sacrificePaths = [];
    // console.log(_sacrifice, "activated");
    if (_sacrificeList != null) {
      // console.log("_sacrificeList run ........");
      _sacrificeList.forEach((item) => {
        this.sacrificePaths.push(item.PhotoPath);
      });
      this.$store.commit("delSacrificeList");
      setTimeout(() => {
        that.jpAnimation();
        that.init();
      }, 100);
    } else if (_sacrifice != null) {
      // console.log("_sacrifice run ........");
      this.sacrificePaths.push(_sacrifice.SacrificePath);
      this.$store.commit("delSacrifice");
      setTimeout(() => {
        that.jpAnimation();
        that.init();
      }, 100);
    }
    if (this.isMusicPay) {
      let memberAudio = document.querySelector("#memberAudio");
      memberAudio.play();
    }
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/zy.css";

root {
  background-color: #2c3e50;
  border-color: #7591ad;
  text-color: #34495e;
  color1: #ec3e27;
  color2: #fd79a8;
  color3: #0984e3;
  color4: #00b894;
  color5: #fdcb6e;
  color6: #e056fd;
  color7: #f97f51;
  color8: #bdc581;
}

.channel {
  position: absolute;
  width: 80%;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -200px);
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  z-index: 999;
}
.container {
  position: relative;
  width: 100vw;
  height: 100vh;

  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 800px;
  /* perspective-origin: left bottom; */
  transform-style: preserve-3d;
}
.line {
  position: absolute;
  width: 100px;
  height: 2px;
  border-radius: 2px;
  /* background-color: #fff; */
  background-image: linear-gradient(
    to right,
    var(--color),
    #ffffff50,
    transparent
  );
  animation: down 15s linear infinite both;
  animation-delay: calc(var(--d) * 0.8s);
}
.line::before,
.line::after {
  position: absolute;
  content: "";
  width: inherit;
  height: inherit;
  background-image: inherit;
}
.line::before {
  filter: blur(5px);
}
.line::after {
  filter: blur(10px);
}
@keyframes down {
  0% {
    transform: translateY(calc(var(--z) * 60px))
      translateZ(calc(var(--z) * 150px)) rotate(-45deg)
      translateX(calc(var(--x) * 100px));
  }
  100% {
    transform: translateY(calc(var(--z) * 60px))
      translateZ(calc(var(--z) * 100px)) rotate(-45deg)
      translateX(calc(var(--x) * -100px));
  }
}
.channel {
  background: linear-gradient(to right, red, blue);
  -webkit-background-clip: text;
  color: transparent;
}

svg {
  position: absolute;
  width: 100%;
  height: 100%;
  visibility: hidden;
  overflow: visible;
}
.release {
  top: 50%;
  left: 50%;
  position: absolute;
  text-align: center;
  transform: translate(-50%, -50%);
  color: #ededed;
  font-family: Microsoft Yahei;
  letter-spacing: 1em;
  user-select: none;
  pointer-events: none;
  width: 100%;
}

@keyframes gif {
  0% {
    background-image: url("~@/assets/images/zy/hl/sbl0001.png");
  }
  7% {
    background-image: url("~@/assets/images/zy/hl/sbl0002.png");
  }
  14% {
    background-image: url("~@/assets/images/zy/hl/sbl0003.png");
  }
  21% {
    background-image: url("~@/assets/images/zy/hl/sbl0004.png");
  }
  28% {
    background-image: url("~@/assets/images/zy/hl/sbl0005.png");
  }
  35% {
    background-image: url("~@/assets/images/zy/hl/sbl0006.png");
  }
  42% {
    background-image: url("~@/assets/images/zy/hl/sbl0007.png");
  }
  49% {
    background-image: url("~@/assets/images/zy/hl/sbl0008.png");
  }
  56% {
    background-image: url("~@/assets/images/zy/hl/sbl0009.png");
  }
  63% {
    background-image: url("~@/assets/images/zy/hl/sbl0010.png");
  }
  70% {
    background-image: url("~@/assets/images/zy/hl/sbl0011.png");
  }
  77% {
    background-image: url("~@/assets/images/zy/hl/sbl0012.png");
  }
  85% {
    background-image: url("~@/assets/images/zy/hl/sbl0013.png");
  }
  92% {
    background-image: url("~@/assets/images/zy/hl/sbl0014.png");
  }
  98% {
    background-image: url("~@/assets/images/zy/hl/sbl0015.png");
  }
  100% {
    background-image: url("~@/assets/images/zy/hl/sbl0016.png");
  }
}

.huogong {
  width: 100px;
  height: 143px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  animation: gif 5s infinite;
  z-index: 100;
  background-image: url("~@/assets/images/zy/hl/sbl0001.png");
  display: none;
}

.huogong2 {
  position: absolute;
  right: 10px;
  z-index: 999;
}

.jp_img {
  position: absolute;
  z-index: 99;
  top: -30px;
  right: 45px;
  width: 50px;
  height: 50px;
  opacity: 0;
}


</style>
